export const isMobileScreen = () => {
  const MOBILE_SCREEN_WIDTH: number = 425;
  return window.innerWidth < MOBILE_SCREEN_WIDTH;
};

export const isWindowLargeEnough = () => {
  const LARGE_WINDOW_WIDTH: number = 1350;
  return window.innerWidth > LARGE_WINDOW_WIDTH;
};

export const dropdownRefContextMenu = (subMenuRef: HTMLUListElement) => {
  if (subMenuRef) {
    if (isMobileScreen()) {
      return;
    }
    if (!isWindowLargeEnough()) {
      subMenuRef.style.left = 'auto';
      subMenuRef.style.right = '100%';
      subMenuRef.style.top = '-10px';
    } else {
      subMenuRef.style.left = '100%';
      subMenuRef.style.right = 'auto';
      subMenuRef.style.top = '-10px';
    }
  }
};
